import { Component, OnInit } from '@angular/core';
import { TotemService } from './totem.service';
import { TotemConfiguracion } from './totem-configuracion';
import {Tienda} from './tiendas/tienda';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
// import { gremlins } from 'gremlins-ts';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  private path;
  private pageView;
  private UA_ID = 'UA-198792829-4';
  tiemporeload;
  isOpen = false;

  constructor(private totemService: TotemService, private router: Router) {
    router.events.subscribe((event) => {
      this.cancelarcontador();
      if (event instanceof NavigationEnd) {
        const array1 = ['tiendas', 'servicios', 'eventos', 'eventosel'];
        if (array1.includes(event.urlAfterRedirects.split('/')[1])) {
          if (this.path === '/buscar' && event.urlAfterRedirects.split('/').length > 2) {
            this.pageView = '/buscar' + event.urlAfterRedirects;
          } else {
            if (this.path === '/ofertas' && event.urlAfterRedirects.split('/').length > 2) {
              this.pageView = '/ofertas' + event.urlAfterRedirects;
            } else {
              this.pageView = '/menu' + event.urlAfterRedirects;
            }
          }
        } else {
          if (event.urlAfterRedirects === '/') {
            this.pageView = '/home';
          } else {
            this.pageView = event.urlAfterRedirects;
          }
        }
        this.pageView = this.pageView.replace('eventosel', 'eventos');
        this.totemService.getTotemConfig()
          .then((config) => {
            //gtag('set','page',config.nombreEdificio.replace(' ','_') + '/' + config.nombre + this.pageView);
            gtag('config', this.UA_ID, {
              'page_path': config.nombreEdificio.replace(' ', '_') + '/' + config.nombre + this.pageView
              }
            );
            console.log(config.nombreEdificio.replace(' ', '_') + '/' + config.nombre + this.pageView);
            this.path = event.urlAfterRedirects;
          });
      }
    });
  }

  async ngOnInit() {

    // const horde = gremlins.createHorde();
    // horde.strategy(gremlins.strategies['distribution']).unleash({ nb: 100000, delay: 50 }, null);

    this.reiniciartotem();
    try {
      // const publicidad = await this.totemService.getpublicidades().toPromise();
      // const peliculas = await this.totemService.geteventos().subscribe(eventos => {});
      const tipoAccesos = await this.totemService.getTipoAccesos().toPromise();
      // const tiendas = await this.totemService.getTiendas().toPromise();
      // const items      = await this.totemService.getCategorias().toPromise();
      const totemConfig = new TotemConfiguracion(await this.totemService.getTotemConfig());
      if (!totemConfig) {
        throw Error('La configuración del totem no se ha obtenido');
      }
    } catch (err) {
      console.error(err);
    }

    this.totemService.change.subscribe(isOpen => {
      this.cancelarcontador();
      this.isOpen = isOpen;
    });

  }
  // ngOnDestroy() {
  //   // unsubscribe to ensure no memory leaks
  //   this.subscription.unsubscribe();
  // }
  //
   otramitad;
   public reiniciartotem() {
     const url = '/';
     const tiempo = environment.timereload;
    // mitad tiempo
      const mitad=tiempo/2;
      this.otramitad = this.tiemporeload=setTimeout(() => {console.log('30s para reinicio');}, mitad*1000);
    //
     this.tiemporeload = setTimeout(() => {
       if(tiempo !== 0) {
        this.router.navigateByUrl(url).then(e => {
          if (e) {
            window.location.reload();
            console.log('ReiniciandoTotem');
          } else {
            console.log('Nosepudoreiniciar');
          }
        });
       }
     }, tiempo * 1000);
   }
   public cancelarcontador(){
    //  console.log('cancelar contador');
     clearTimeout(this.otramitad);
     clearTimeout(this.tiemporeload);
     this.reiniciartotem();
   }

}
